"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsForm.titleCreate': 'Añadir número de teléfono WhatsApp',
    'whatsapp.settingsForm.titleEdit': 'Editar número de teléfono WhatsApp',
    'whatsapp.settingsForm.back': 'Volver',
    'whatsapp.settingsForm.loadFailed': 'No se pudo cargar la configuración de WhatsApp.',
};
